import { getS3FileContent } from "@/pages/api/cache-pages";
import { AWS_STRAPI_JSON_DATA_FOLDER_NAME } from "@/utils/utils";
import axios, { AxiosInstance } from "axios";

const api: AxiosInstance = axios.create({
  baseURL:
    process.env.ENV_NAME === "development"
      ? process.env.CMS_API_BASE_URL_QA
      : process.env.ENV_NAME === "uat"
      ? process.env.CMS_API_BASE_URL_UAT
      : process.env.CMS_API_BASE_URL_PROD,
});

export const fetchCommonData = async (): Promise<any> => {
  try {
    const response = await api.get(`api/common-page`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data for the common page:`, error);
    const response = await getS3FileContent(
      `${AWS_STRAPI_JSON_DATA_FOLDER_NAME}/common-page.json`
    );
    return response;
  }
};
